import styled from '@emotion/styled';
import CURRENT_CHAIN from 'constants/chainInfo';

type Props = {
  tokenId: number;
  transactionHash: string;
  image: string;
};

// https://opensea.io/assets/klaytn/0xce70eef5adac126c37c8bc0c1228d48b70066d03/8081

const ChildSuccess = ({ tokenId, transactionHash, image }: Props) => {
  const { name: networkName, isMainNet, contract } = CURRENT_CHAIN;
  const baseUrl = isMainNet
    ? 'https://opensea.io/assets'
    : 'https://testnets.opensea.io/assets';

  return (
    <SuccessInfoWrapper>
      <Badge src='images/modal_success.png' alt='success image' />
      <ContentsWrapper>
        <TitleWrapper>
          <Title>민팅성공</Title>
          <SubTitle>나만의 NFT를 확인해보세요.</SubTitle>
        </TitleWrapper>
        <MintImage src={image} alt='gummy image' />
      </ContentsWrapper>
      <ExtraLink
        href={`${baseUrl}/${networkName}/${contract.DEPLOYED_ADDRESS}/${tokenId}`}
        target='_blank'
        rel='noreferrer'
        onClick={() => alert('OpenSea 동기화까지는 1분 정도 소요됩니다.')}
      >
        NFT 보러가기
      </ExtraLink>
    </SuccessInfoWrapper>
  );
};

export const Badge = styled.img`
  position: absolute;
  top: -40px;

  width: 73px;
  height: 73px;
  object-fit: contain;
`;

const SuccessInfoWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  padding-top: 51px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const MintImage = styled.img`
  width: 180px;
  height: 180px;

  object-fit: contain;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;

  width: 100%;
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  color: #4d5ced;
`;

const SubTitle = styled.div`
  text-align: center;
  font-size: 16px;
  color: #505050;
`;

const ExtraLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 360px;
  height: 60px;
  background-color: var(--bg-color);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  cursor: pointer;
  vertical-align: middle;
  font-size: 20px;
  :hover {
    background-color: #f7aedc;
  }
`;

export default ChildSuccess;
